import {
  ArcgisOptions,
  FeatureService,
  GeoJsonSourceOptions,
} from "@areahub/arcgis";
import { useRef, useState } from "react";
import { type LayerProps } from "react-map-gl";

export type FeatureServiceLayerDefinition = LayerProps & {
  id: string;
  source: string;
};

export type UseFeatureServiceArgs = {
  url: string;
  layer: FeatureServiceLayerDefinition;
  arcgisOptions?: Omit<ArcgisOptions, "url">;
  geojsonSourceOptions?: GeoJsonSourceOptions;
};
export function useFeatureService({
  url,
  layer,
  arcgisOptions,
  geojsonSourceOptions,
}: UseFeatureServiceArgs) {
  const [service, setService] = useState<FeatureService | null>(null);
  // TODO: change ref type to MapRef from 'react-map-gl'
  const ref = useRef<any>(null);
  const onLoad = () => {
    const fs = new FeatureService(
      layer.source,
      ref?.current?.getMap(),
      {
        url: url,
        ...arcgisOptions,
      },
      geojsonSourceOptions,
    );
    ref.current?.getMap().addLayer(layer);
    setService(fs);
  };

  return {
    onLoad,
    ref,
    service,
  };
}

export type FeatureServiceOptions = {
  url: string;
  layer: FeatureServiceLayerDefinition;
  arcgisOptions?: Omit<ArcgisOptions, "url">;
  geojsonSourceOptions?: GeoJsonSourceOptions;
};
